// Test de CÓMO APRENDES — lo que el alumno declara.
//
// Es A5 y su cara legal V19, y por eso está construido al revés que los otros tres: aquí no
// se puntúa nada ni se deduce nada. **Cada respuesta ES un ajuste que ya existe** en la
// página de Ajustes, con la forma `preferencia:valor` — los mismos de
// `lib/preferencias.mjs`, ni uno más. Preguntarle a un menor por algo que después no cambia
// nada es pedirle datos para no usarlos, así que aquí no se pregunta.
//
// POR QUÉ UN TEST Y NO LA PÁGINA DE AJUSTES, si es lo mismo: porque no es lo mismo de leer.
// Nueve filas de opciones con títulos como «Movimiento · Cuánto se mueve la plataforma» son
// una pantalla de configuración, y un chaval de catorce no entra ahí ni sabe qué le
// conviene. «¿Lo que se mueve en pantalla te ayuda o te despista?» sí lo sabe contestar. La
// página de Ajustes se queda donde estaba, y sigue mandando: esto es otra puerta al mismo
// sitio, no un sitio nuevo.
//
// Y LA REGLA HEREDADA DE `preferencias.mjs`: cada opción se describe por lo que hace, nunca
// por a quién va dirigida. Ni una palabra clínica en una etiqueta.
export const PREGUNTAS_APRENDES = [
  {
    id: "p1",
    prompt: "Nada de esto se deduce: lo dices tú, y se aplica.",
    question: "Cuando el mentor te explica algo, ¿a qué ritmo lo quieres?",
    options: [
      { id: "a", label: "Mensaje a mensaje, con tiempo para leer cada uno", weights: { "ritmo:pausado": 1 } },
      { id: "b", label: "Como está ahora", weights: { "ritmo:normal": 1 } },
      { id: "c", label: "Todo seguido, y ya lo paro yo si hace falta", weights: { "ritmo:rafaga": 1 } },
    ],
  },
  {
    id: "p2",
    prompt: "Sobre quién pasa de mensaje:",
    question: "Cuando el mentor termina un mensaje, ¿sigue él solo o pasas tú?",
    options: [
      { id: "a", label: "Que siga él, yo voy leyendo", weights: { "avance:solo": 1 } },
      { id: "b", label: "Yo voy pasando: que espere a que se lo diga", weights: { "avance:yo": 1 } },
    ],
  },
  {
    id: "p3",
    prompt: "Sobre los cambios de pantalla:",
    question: "Cuando la pantalla va a cambiar, ¿quieres saberlo antes?",
    options: [
      { id: "a", label: "No hace falta: que cambie sin más", weights: { "aviso:directo": 1 } },
      { id: "b", label: "Sí: dime a dónde voy antes de que cambie", weights: { "aviso:anticipado": 1 } },
    ],
  },
  {
    id: "p4",
    prompt: "Sobre lo que hay que leer:",
    question: "¿Cómo se te lee mejor un texto largo?",
    options: [
      { id: "a", label: "Como está", weights: { "texto:normal": 1 } },
      { id: "b", label: "Más separado, que las líneas no se me peguen", weights: { "texto:comodo": 1 } },
      { id: "c", label: "Más separado y con otra letra, que se distinga mejor", weights: { "texto:maxima": 1 } },
    ],
  },
  {
    id: "p5",
    prompt: "Sobre el reloj:",
    question: "Ver cuánto tiempo te queda, ¿te ayuda o te pone nervioso?",
    options: [
      { id: "a", label: "Me ayuda: quiero ver la cuenta atrás", weights: { "reloj:normal": 1 } },
      { id: "b", label: "Prefiero una barra que avanza, sin números", weights: { "reloj:barra": 1 } },
      { id: "c", label: "Me agobia: mejor sin cuenta atrás", weights: { "reloj:sin": 1 } },
    ],
  },
  {
    id: "p6",
    prompt: "Sobre lo que se mueve en pantalla:",
    question: "Las animaciones, ¿te gustan o te despistan?",
    options: [
      { id: "a", label: "Me gustan, que se mueva", weights: { "movimiento:completo": 1 } },
      { id: "b", label: "Lo que ya tenga puesto mi móvil u ordenador", weights: { "movimiento:sistema": 1 } },
      { id: "c", label: "Me despistan: prefiero que esté quieto", weights: { "movimiento:reducido": 1 } },
    ],
  },
  {
    id: "p7",
    prompt: "Sobre el sonido:",
    question: "¿Qué quieres que suene mientras estudias?",
    options: [
      { id: "a", label: "Todo: música, efectos y fanfarrias", weights: { "sonido:todo": 1 } },
      { id: "b", label: "Los avisos sí, la música y las fanfarrias no", weights: { "sonido:sin-juego": 1 } },
      { id: "c", label: "Nada. Silencio.", weights: { "sonido:silencio": 1 } },
    ],
  },
  {
    id: "p9",
    prompt: "La última, sobre los colores:",
    question: "¿Cómo ves mejor la pantalla?",
    options: [
      { id: "a", label: "Como está", weights: { "tema:alpha": 1 } },
      { id: "b", label: "Con más contraste, que se lea más claro", weights: { "tema:contraste": 1 } },
      { id: "c", label: "Con colores menos intensos, que cansan menos", weights: { "tema:calma": 1 } },
    ],
  },
];
